/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import * as AnonymousConsentsSelectors from './anonymous-consents-group.selectors';
export { AnonymousConsentsSelectors };
